<template>
    <row class="relative" no-wrap>
        <column class="flex-1">
            <row :justify="innerWidth > 1550 ? 'space-between' : 'start'" :no-wrap="innerWidth > 1550" align="stretch">
                <column shrink>
                    <divider class="mb-3" color="primary" width="56"></divider>
                    <div class="poppins-bold tracking-normal xs:text-3xl sm:text-5xl text-secondary xs:mb-2 sm:mb-4">
                        Why
                    </div>
                    <div
                        class="poppins-bold tracking-normal xs:leading-relaxed sm:leading-highest xs:text-7xl sm:text-10xl text-secondary">
                        fitt
                    </div>
                </column>
                <column :class="innerWidth < 1550 ? 'w-full' : ''" align="center">
                    <template v-if="innerWidth < 1360">
                        <!-- -translate-x-6, value must equal that of the outer container's padding in Home.vue -->
                        <tw-carousel :options="options" class="w-screen transform -translate-x-6" ref="carousel" style="max-height: 412px; min-height: 412px;">
                            <column :key="itemIndex"
                                    class="px-5 pt-20 pb-6 flex-1 justify-center z-10"
                                    v-for="({src, title, subtitle}, itemIndex) of items"
                            >
                                <card class="flex flex-col justify-end items-center text-secondary relative"
                                      no-padding
                                      overflow="visible"
                                      style="min-width: 300px; max-width: 300px; min-height: 321px; max-height: 321px"
                                >
                                    <object :data="src" :id="'carouselObject_'+itemIndex"
                                            class="absolute"
                                            @load="animate(itemIndex)"
                                            style="min-width: 300px; max-width: 300px; max-height: 230px; min-height: 230px; top: -50px; pointer-events: none;"
                                            type="image/svg+xml"
                                    ></object>
                                    <div class="mb-10 flex flex-col items-center">
                                        <divider class="mb-3" color="primary" width="56"></divider>
                                        <div
                                            class="uppercase mt-4 w-full text-secondary text-center poppins-bold tracking-wide leading-tight"
                                            v-html="title"
                                        ></div>
                                        <div class="lowercase text-secondary text-center tracking-tight">{{subtitle}}
                                        </div>
                                    </div>
                                </card>
                            </column>
                        </tw-carousel>
                    </template>
                    <template v-else>
                        <div class="rounded-full absolute w-48 h-48 bg-primary z-0"
                             style="left: -100px; top: -100px; opacity: 0.05;"></div>
                        <row :class="innerWidth < 1550 ? 'pt-20' : 'pt-10'" align="stretch"
                             class="text-center -mx-4 z-10" justify="center" no-wrap>
                            <column :key="itemIndex" align="center" class="xs:px-4 sm:px-6"
                                    v-for="({src, title, subtitle}, itemIndex) of items"
                            >
                                <card class="flex flex-col justify-end items-center text-secondary relative"
                                      overflow="visible"
                                      style="min-width: 300px; max-width: 300px; min-height: 321px; max-height: 321px"
                                >
                                    <object :data="src" :id="'rowObject_'+itemIndex"
                                            class="absolute"
                                            @load="animate(itemIndex)"
                                            style="min-width: 300px; max-width: 300px; top: -50px;"
                                            type="image/svg+xml"
                                    ></object>
                                    <divider class="mb-5" color="primary" width="56"></divider>
                                    <div
                                        class="uppercase mt-4 w-full text-secondary text-center poppins-bold tracking-wide leading-tight"
                                        v-html="title"
                                    ></div>
                                    <div class="lowercase text-secondary text-center tracking-tight">{{subtitle}}</div>
                                </card>
                            </column>
                        </row>
                    </template>
                </column>
            </row>
        </column>
    </row>
</template>

<script>
    import anime from "animejs";
    import Helpers from "../../mixins/Helpers";

    export default {
        mixins: [Helpers],
        components: {
            'card': () => import('@/components/Card.vue'),
            'divider': () => import('@/components/Divider.vue'),
            'tw-carousel': () => import('@/components/TwCarousel.vue')
        },
        computed: {
            mobile() {
                return innerWidth <= parseInt(this.$theme.screens.lg.min.replace('px', ''));
            }
        },
        data: () => ({
            items: [
                {
                    src: require('@/assets/images/homepage/create_experience.svg'),
                    title: 'Create <br> Experience',
                    subtitle: 'promote employer brand',
                },
                {
                    src: require('@/assets/images/homepage/gather_predictive_data.svg'),
                    title: 'Gather <br> predictive data',
                    subtitle: 'for business continuity',
                },
                {
                    src: require('@/assets/images/homepage/lead_strategic_dev.svg'),
                    title: 'Lead strategic <br> development',
                    subtitle: 'right areas, right time',
                },
                {
                    src: require('@/assets/images/homepage/feedback_and_coaching.svg'),
                    title: 'Create feedback and <br> coaching cultures',
                    subtitle: 'empower performance',
                }
            ],
            innerWidth: 0,
            options: {
                pageDots: false,
                // wrapAround: false,
                cellAlign: 'left'
            }
        }),
        methods: {
            setInnerWidth(render = true) {
                this.innerWidth = window.innerWidth;
                this.options.pageDots = this.innerWidth < 1325;
                if (render && this.innerWidth < 1360) {
                    this.$nextTick(() => {
                        this.$refs.carousel.reRender();
                    });
                }
                if (this.innerWidth < 1000) {
                    this.options.cellAlign = 'center'
                } else {
                    this.options.cellAlign = 'left'
                }
            },
            getElement(item, id) {
                return item.contentDocument.querySelector(id);
            },
            setInitialPosition(target, x, y) {
                anime.set(target, {translateX: x, translateY: y});
            },
            initAnimations() {
                this.items.forEach((item, index) => {
                    let main = this.$el.querySelector('#carouselObject_' + index) || this.$el.querySelector('#rowObject_' + index);
                    if (index === 0) {
                        let pencil = this.getElement(main, '#Group_53'),
                            rightArm = this.getElement(main, '#Path_135'),
                            leftArm = this.getElement(main, '#Group_54'),
                            hand_1 = this.getElement(main, '#Path_133'),
                            hand_2 = this.getElement(main, '#Path_134'),
                            hand_3 = this.getElement(main, '#Path_129'),
                            hand_4 = this.getElement(main, '#Path_128'),
                            shoulder = this.getElement(main, '#Path_153'),
                            line = this.getElement(main, '#Path_124');
                        this.setInitialPosition(pencil, 0, 28.537);
                        this.setInitialPosition(rightArm, -270.283, -132.502);
                        this.setInitialPosition(leftArm, 7.786, 32.718);
                        this.setInitialPosition(hand_1, -235.417, -136.118);
                        this.setInitialPosition(hand_2, -237.899, -137.092);
                        this.setInitialPosition(hand_3, -371.041, -214.577);
                        this.setInitialPosition(hand_4, -372.952, -214.577);
                        this.setInitialPosition(shoulder, -251.378, -130.61);
                        this.setInitialPosition(line, -130.119, -105.036);
                        this.animatePencil(pencil, -9, 2, 2000);
                        this.animateHand(
                            hand_1,
                            hand_2,
                            -9,
                            -230.417,
                            -120,
                            -7,
                            -232.899,
                            -121.5,
                            2000
                        );
                        this.animateRightHand(hand_3, -5, -367.5, 2000);
                        this.animateRightHand(hand_4, -5, -370, 2000);
                        this.animateArm(rightArm, -5, -268.283, 2000);
                        this.animateArm(leftArm, -26, 8.786, 2000);
                        this.animateShoulder(shoulder, -23, -251.378, 2000);
                    } else if (index === 1) {
                        let bar_1 = this.getElement(main, '#Rectangle_120'),
                            bar_1_shadow = this.getElement(main, '#Rectangle_117'),
                            bar_2 = this.getElement(main, '#Rectangle_119'),
                            bar_2_shadow = this.getElement(main, '#Rectangle_116'),
                            bar_3 = this.getElement(main, '#Rectangle_121'),
                            bar_3_shadow = this.getElement(main, '#Rectangle_118');
                        this.setInitialPosition(bar_1, 46.661, 0);
                        this.setInitialPosition(bar_1_shadow, 57.478, 0);
                        this.setInitialPosition(bar_2, 0, 44.85);
                        this.setInitialPosition(bar_2_shadow, 10.818, 44.85);
                        this.setInitialPosition(bar_3, 93.321, 44.85);
                        this.setInitialPosition(bar_3_shadow, 104.139, 44.85);
                        this.animateBar([bar_1, bar_1_shadow], 140.55, 40, 6000, 2000);
                        this.animateBar([bar_2, bar_2_shadow], 175.7, 5, 6000);
                        this.animateBar([bar_3, bar_3_shadow], 175.7, 5, 6000, 4000);
                    } else if (index === 2) {
                        let icon_1 = this.getElement(main, '#Group_128'),
                            icon_2 = this.getElement(main, '#Group_130'),
                            icon_3 = this.getElement(main, '#Group_133');
                        this.setInitialPosition(icon_1, 55.548, 25.164);
                        this.setInitialPosition(icon_2, 52.045, 50.299);
                        this.setInitialPosition(icon_3, 48.542, 75.435);
                        this.animateIcons([icon_1, icon_2, icon_3], 1.1, 1000, 1000);
                    } else {
                        let bubble = this.getElement(main, '#Bubble_Speech'),
                            arm_1 = this.getElement(main, '#Path_483'),
                            speech_hand_1 = this.getElement(main, '#Path_484'),
                            speech_shoulder_1 = this.getElement(main, '#Path_485');
                            // arm_2 = this.getElement(main, '#Path_371'),
                            // speech_shoulder_2 = this.getElement(main, '#Path_372');
                        this.setInitialPosition(bubble, 53.301, 81.126);
                        this.setInitialPosition(arm_1, -198.846, -140.799);
                        this.setInitialPosition(speech_hand_1, -210.618, -148.104);
                        this.setInitialPosition(speech_shoulder_1, -197.193, -139.722);
                        // this.setInitialPosition(arm_2, -312.639, -163.766);
                        // this.setInitialPosition(speech_shoulder_2, -319.171, -162.618);
                        this.animateBubble(bubble, 1.02, 51.301, 79.126, 4000);
                        this.animateArm(arm_1, -15, -198.846, 2000, '10% 10%');
                        this.animateSpeechArms(speech_hand_1, -18, -208.618, -153.104, 2000);
                        this.animateShoulder(speech_shoulder_1, -15, -195.193, 2000, '50% 50%');
                        // this.animateArm(arm_2, -15, -312.639, 2000, '90% 10%');
                    }
                });
            },
            animatePencil(pencil, rotation, translate, duration) {
                anime.set(pencil, {transformOrigin: '100% 50%', transformBox: 'fill-box'});
                anime({
                    targets: pencil,
                    rotate: rotation,
                    translateX: translate,
                    direction: 'alternate',
                    easing: 'linear',
                    duration: duration,
                    loop: true
                });
            },
            animateHand(hand_1, hand_2, handOneRotation, handOneTranslateX, handOneTranslateY, handTwoRotation, handTwoTranslateX, handTwoTranslateY, duration) {
                anime.set(hand_1, {transformOrigin: '100% 50%', transformBox: 'fill-box'});
                anime.set(hand_2, {transformOrigin: '100% 50%', transformBox: 'fill-box'});
                anime({
                    targets: hand_1,
                    rotate: handOneRotation,
                    translateX: handOneTranslateX,
                    translateY: handOneTranslateY,
                    direction: 'alternate',
                    easing: 'linear',
                    duration: duration,
                    loop: true
                });
                anime({
                    targets: hand_2,
                    rotate: handTwoRotation,
                    translateX: handTwoTranslateX,
                    translateY: handTwoTranslateY,
                    direction: 'alternate',
                    easing: 'linear',
                    duration: duration,
                    loop: true
                });
            },
            animateRightHand(hand_3, rotation, translate, duration) {
                anime.set(hand_3, {transformOrigin: '100% 50%', transformBox: 'fill-box'});
                anime({
                    targets: hand_3,
                    rotate: rotation,
                    translateX: translate,
                    direction: 'alternate',
                    easing: 'linear',
                    duration: duration,
                    loop: true
                });
            },
            animateArm(arm, rotation, translate, duration, origin = '100% 50%') {
                anime.set(arm, {transformOrigin: origin, transformBox: 'fill-box'});
                anime({
                    targets: arm,
                    rotate: rotation,
                    translateX: translate,
                    direction: 'alternate',
                    easing: 'linear',
                    duration: duration,
                    loop: true
                });
            },
            animateShoulder(shoulder, rotation, translate, duration, origin = '100% 50%') {
                anime.set(shoulder, {transformOrigin: origin, transformBox: 'fill-box'});
                anime({
                    targets: shoulder,
                    rotate: rotation,
                    translateX: translate,
                    direction: 'alternate',
                    easing: 'linear',
                    duration: duration,
                    loop: true
                });
            },
            animateBar(bars, height, translate, duration, delay = 0) {
                anime({
                    targets: bars,
                    height: height,
                    translateY: translate,
                    direction: 'alternate',
                    easing: 'linear',
                    duration: duration,
                    delay: delay,
                    loop: true
                });
            },
            animateIcons(icons, scale, duration, stagger = 0) {
                anime({
                    targets: icons,
                    keyframes: [
                        {scale: scale},
                        {scale: 1}
                    ],
                    easing: 'linear',
                    duration: duration,
                    delay: anime.stagger(stagger),
                    loop: true
                });
            },
            animateBubble(bubble, scale, translateX, translateY, duration) {
                anime({
                    targets: bubble,
                    keyframes: [
                        {scale: scale, translateX: translateX, translateY: translateY},
                        {scale: 1, translateX: 53.301, translateY: 81.126}
                    ],
                    easing: 'linear',
                    direction: 'alternate',
                    duration: duration,
                    loop: true
                });
            },
            animateSpeechArms(item, rotation, translateX, translateY, duration, origin = '50% 50%') {
                anime.set(item, {transformOrigin: origin, transformBox: 'fill-box'});
                anime({
                    targets: item,
                    rotate: rotation,
                    translateX: translateX,
                    translateY: translateY,
                    direction: 'alternate',
                    easing: 'linear',
                    duration: duration,
                    loop: true
                });
            },
            animate(index){
                if(index === 3) {
                    this.initAnimations();
                }
            }
        },
        mounted() {
            window.addEventListener('resize', this.debounce(this.setInnerWidth, 500));
            this.setInnerWidth(false);
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setInnerWidth);
        }
    };
</script>